/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuRadioSelectList_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterItemType_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterItemType_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuRadioSelectList_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterItemType_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterItemType_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectList_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2725e52c64951d20191b9a0477fc0919';
module.exports = node;
